import { MapPin } from '@phosphor-icons/react/dist/csr/MapPin';
import { forwardRef } from 'react';

import { IconBase } from './base/IconBase';
import type { Icon } from './base/types';

export const IconMapPin: Icon = forwardRef((props, ref) => (
  <IconBase
    {...props}
    variants={['outlined', 'filled']}
    defaultVariant="outlined"
    phosphorIcon={MapPin}
    ref={ref}
  />
));

IconMapPin.variants = ['outlined', 'filled'];
IconMapPin.defaultVariant = 'outlined';
